// extracted by mini-css-extract-plugin
module.exports = {"record":"C1nt","imgLink":"C1o9","imageWrap":"C1o-","image":"C1ob","infoWrap":"C1nx","leadLink":"C1l9","comments":"C1m7","advMarker":"C1lx"};